var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"TeleporCreatQuestion"}}),_c(_setup.ModalNewQuestion,[_c(_setup.ButtonFilter,{attrs:{"id":"profit_btn_criarpergunta","img":_setup.question,"title":"Criar pergunta"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }